import apiRequest from '@/services/api-request';
import {getCookieValue, removeCookie} from '@/util/cookies.js';
import loggingDevInfo from '@/services/log-dev-info';

const defaultRequestOptions = {
	withCredentials: true,
};

export default {
	methods: {
		saveWorkflowIDToLocalStorage() {
			if (this.$store.state.supportsLocalStorage && this.$store.state.workflowID) {
				localStorage.setItem('lsWorkflowID', this.$store.state.workflowID);
			}
		},
		sendCookies() {
			if (!this.checkIfLoggedIn()) return false;
			let jwtExpired = this.isJwtExpired();
			if (jwtExpired) {
				this.resetJwtCookie();
			}
			return !jwtExpired;
		},
		createAxiosConfig(url, method, data) {
			return {
				method,
				url,
				headers: {
					'Content-Type': 'application/json',
					'Country': this.$store.state.COUNTRY,
				},
				withCredentials: this.sendCookies(),
				data,
			};
		},
		resetJwtCookie() {
			removeCookie('jwt');
			this.$store.commit('setJWT', null);
		},
		async callToApi(url, method, data = '') {
			try {
				const response = await apiRequest(url, method, data, null, defaultRequestOptions);
				return response;
			} catch (err) {
				if (err.response.status === 401) this.resetJwtCookie();
				loggingDevInfo(err);
				return false;
			}
		},
		callToApiSave(url, method, data = '') {
			if (!getCookieValue('jwt')) {
				return new Promise((resolve, reject) => {
					this.saveWorkflowIDToLocalStorage();
					this.sendToLogin(true);
					reject();
				});
			}
			return apiRequest(url, method, data, null, defaultRequestOptions)
				.then((response) => response)
				.catch((err) => {
					if (err.response.status === 401) {
						// save workflowID
						this.saveWorkflowIDToLocalStorage();
						this.resetJwtCookie();
						this.sendToLogin(true);
						throw err;
					}
					if (err.response.status < 200 || err.response.status >= 300) this.saveBtnError();
					loggingDevInfo(err);
					throw err;
				});
		},
		callToApiGetSnapshot(url, method) {
			return apiRequest(url, method)
				.then((response) => response)
				.catch((err) => {
					loggingDevInfo(err);
					throw err;
				});
		},
		async callToApiMyWorkflow(url, method, data = '') {
			if (!getCookieValue('jwt')) {
				this.saveWorkflowIDToLocalStorage();
				return this.sendToLogin(false);
			}
			try {
				const response = await apiRequest(url, method, data, null, defaultRequestOptions);
				return response;
			} catch (err) {
				if (err.response.status === 401) {
					// save workflowID
					this.saveWorkflowIDToLocalStorage();
					this.resetJwtCookie();
					return this.sendToLogin(false);
				}
				loggingDevInfo(err);
			}
		},
	},
};
